<!--
	* @Description: 学生奖励 修改
	* @Author: ZSC
	* @Date: 2023-04-07 15:27:27.808
 * @LastEditors: PF
 * @LastEditTime: 2025-06-06 17:18:23
-->
<template>
	<div>
		<el-dialog class="w800 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
			<template #header>
				<div class="header-left">
					<el-icon class="header-icon"><Edit /></el-icon>
					<span class="header-title">修改</span>
				</div>
				<div class="header-right">
					<el-button type="info" text @click="closeWindow('openEdit', emits, false)">
						<el-icon><Close /></el-icon>
					</el-button>
				</div>
			</template>
			<el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学生" prop="xsid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xsid" clearable filterable >
                <el-option v-for="item in xsData" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班级" prop="bjid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.bjid" clearable filterable  @change="xsChange">
                <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班主任" prop="bzrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select disabled v-model="ruleForm.bzrid" clearable filterable >
                <el-option v-for="item in jzgData" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" clearable filterable >
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励名称" prop="jlmc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.jlmc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励级别" prop="jljbid" >
              <el-select v-model="ruleForm.jljbid" clearable filterable >
                <el-option v-for="item in jljbData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励等级" prop="jldjid">
              <el-select v-model="ruleForm.jldjid" clearable filterable >
                <el-option v-for="item in jldjData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="获奖类别" prop="hjlbid" >
              <el-select v-model="ruleForm.hjlbid" clearable filterable >
                <el-option v-for="item in jljblist" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励金额" prop="jlje">
              <el-input-number v-model="ruleForm.jlje" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励文号" prop="jlwh" >
              <el-input v-model="ruleForm.jlwh" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="颁奖单位名称" prop="bjdwmc" >
              <el-input v-model="ruleForm.bjdwmc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励类型" prop="jllxid" >
              <el-select v-model="ruleForm.jllxid" clearable filterable >
                <el-option v-for="item in jllxData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖励方式" prop="jlfsid">
              <el-select v-model="ruleForm.jlfsid" clearable filterable >
                <el-option v-for="item in jlfsData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
			<template #footer>
				<div class="dialog-footer">
					<div></div>
					<div class="footer_but">
						<el-button type="primary" @click="submit()">保存</el-button>
						<el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { submitEditForm, closeWindow, loadData,loadSelect } from '@/api/common.js'
 import { loadZiDianSelect } from '@/api/queryZiDian.js'
// import { loadJiGouCascader } from '@/api/queryJiGou.js'

const props = defineProps({ openEdit: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const jljbData = ref()
  const jldjData = ref()
  const hjlbData = ref()
  const jllxData = ref()
  const jlfsData = ref()
  const xqData = ref()
  const xsData = ref()
  const bjData = ref()
  const jzgData = ref()
  const xsChange = (val) => {
    
    loadSelect({ url: '/api/v2/pdp/xuesheng/banjixuesheng', data: xsData, parms: { bjid: val }, order: 'xh', sort: 'asc' })
    bjData.value.forEach((element) => {
      if (element.id === val) {
        // ruleForm.value.bzrid = element.bzrid
      }
    })
  }

 watch(
	() => props.openEdit,
	() => {
		if (props.openEdit) {
        loadZiDianSelect('奖励级别', jljbData)
        loadZiDianSelect('奖励等级', jldjData)
        loadZiDianSelect('学生获奖类别', hjlbData)
        loadZiDianSelect('奖励类型', jllxData)
        loadZiDianSelect('奖励方式', jlfsData)
        loadSelect({ url: '/api/v2/pdp/xueqi/list', data: xqData, order: 'sx', sort: 'asc' })
        loadSelect({url: '/api/v2/pdp/banji/list', data: bjData,parms:{bzrid:props.row.jzgid}, order: 'xzbmc', sort: 'asc'})
        loadSelect({ url: '/api/v2/pdp/jiaozhigong/list', data: jzgData, order: 'gh', sort: 'asc' })
        loadSelect({ url: '/api/v2/pdp/xuesheng/list', data: xsData, order: 'xh', sort: 'asc' })
			loadData({
				url: '/api/v2/xuesheng/xueshengjiangli/' + props.row.id,
				ruleForm,
				loadSuccess: function (res) {
                    
				}
			})
		}
	},
	{ deep: true, immediate: true }
 )

// 提交
const submit = async () => {
	// ruleForm.value.kkdwid = Array.isArray(ruleForm.value.kkdwid) ? ruleForm.value.kkdwid[ruleForm.value.kkdwid.length - 1] : ruleForm.value.kkdwid
	submitEditForm({
		url: '/api/v2/xuesheng/xueshengjiangli',
		ruleFormRef: unref(ruleFormRef),
		ruleForm: ruleForm.value,
		callback: function (res) {
			closeWindow('openEdit', emits, true)
		}
	})
}
</script>
